<template v-if="!post">
    <div>
        <div class="rounded-md w-full aspect-video shrink-0 bg-gray-200 animate-pulse"></div>

        <div class="p-2 lg:p-3">
            <div class="flex flex-row gap-4 items-center justify-between">
                <div class="transition-all ease-in-out bg-gray-200 h-8 w-8 rounded-full animate-pulse"></div>
                <div class="text-sm space-y-1">
                    <div class="h-2 bg-gray-200 rounded w-16 animate-pulse"></div>
                    <div class="h-3 bg-gray-200 rounded w-24 animate-pulse"></div>
                </div>
            </div>

            <div class="mt-4 space-y-2">
                <div class="h-3 bg-gray-200 rounded w-full animate-pulse"></div>
                <div class="h-3 bg-gray-200 rounded w-1/2 animate-pulse"></div>
            </div>
        </div>
    </div>
</template>
